<template lang="pug">
  v-card.mx-auto
    v-card-title
      div Grupos de edad 
      v-spacer
      .float-right {{daySelected.date | date-format-string}}
    GChart(v-if="chartData.length > 0",
          :settings="{ packages: ['corechart'] }",
           type="PieChart", :data="chartData", :options="chartOptions")
    v-card-text.text--primary
      div Casos confirmados acumulados por grupos de edad
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },
  props: {
    daySelected: {
      type: Object
    }
  },
  data() {
    return {
      chartData: [],
      chartOptions: {
        // title: 'Company Performance',
        // subtitle: 'Sales, Expenses, and Profit: 2014-2017',
      }
    }
  },
  watch: {
    daySelected: function() {
      this.reloadChart()
    }
  },
  methods: {
    reloadChart() {
      this.chartData = [
        ['Edad', 'Cantidad'],
        ['0 - 19', this.daySelected.age0to19],
        ['20 - 39', this.daySelected.age20to39],
        ['40 - 59', this.daySelected.age40to59],
        ['60 - 79', this.daySelected.age60to79],
        ['80 - 99', this.daySelected.age80to99],
        ['100 - más', this.daySelected.age100plus]
      ]
    }
  },
  mounted() {
    this.reloadChart()
  }
}
</script>
